import React from 'react';
import { CostItem, EstimatedFees, EstimatedProfit } from '../components/CostItem';
export const ManualPricing = ({ includeFeesValue, cost, unitProfit, feesValue }) => {
    return (React.createElement("div", null,
        cost && React.createElement(CostItem, { name: "Manufacturing costs", value: cost, negative: true }),
        includeFeesValue && React.createElement(EstimatedFees, { value: feesValue }),
        React.createElement(EstimatedProfit, { value: unitProfit })));
};
